import React from "react"

import { Element, ElementProps } from "legacy/components/shared/base"
import { PrismicPageDataBodyHorizontalRule } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  data: PrismicPageDataBodyHorizontalRule
}

export type HorizontalRuleProps = OwnProps & ElementProps

const HorizontalRule: React.FC<HorizontalRuleProps> = ({
  data,
}): React.ReactElement => {
  const primary = data?.primary

  const { color, rule_width, vertical_spacing } = primary

  const spacingValues: Record<string, number> = {
    standard: 100,
    halved: 50,
    quartered: 25,
    none: 0,
  }

  const marginY = vertical_spacing
    ? spacingValues[vertical_spacing]
    : spacingValues.standard

  return (
    <Element px={["40"]}>
      <Element
        bg={color}
        height="1px"
        m={`${marginY}px auto`}
        maxWidth="contentWidth"
        width={rule_width}
      />
    </Element>
  )
}

export default HorizontalRule
